import React, { FunctionComponent, useState, useEffect } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../../lib/server_helper';
import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import EmailIcon from '@mui/icons-material/Email';

import {
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  Paper,
} from '@mui/material';

import {
  Button,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { User } from '../../../models/User';

// const { DateTime } = require("luxon");

type Props = {}

export const CoachSettingsNotifications: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  const [extendedUser, setExtendedUser] = useState<User>();
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [removeOpen, setRemoveOpen] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [activeId, setActiveId] = useState<number>(login?.id || 0);

  const fields = [
    'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'get_item', 'type', 'settings',
    'practice|id/name/item_is_square/get_medium', 'calendar_url', 'birth_date', 'get_bg_medium', 'profile_text', 'is_background_colour',
    'gender', 'street', 'number', 'zip', 'city', 'country_id', 'phone_mobile', 'phone_fixed', 'coach_skills', 'background_colour', 'ehealth',
    'get_medium', 'is_super'
  ];

  const {
    data: coaches,
    isLoading: coachesLoading,
    isError: coachesError,
    isSuccess: coachesSuccess,
    refetch: coachesRefetch,
  } = useQuery({
    queryKey: ["coaches", currentPractice?.id],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'coach',
          fields: ['id', 'full_name'],
          filter: {
            search: '',
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              is_secretary: '0',
              enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });
  const {
    data: extendedUserTemp,
    isLoading: extendedUserLoading,
    isError: extendedUserError,
    isSuccess: extendedUserSuccess,
    refetch: aextendedUserRefetch,
  } = useQuery({
    queryKey: ["extendeduser", activeId],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: fields,
          id: activeId
        },
        login
      ),
      // select: (d) => {
      //   return d.custom_result;
      // },
    enabled: !!activeId,
  });






  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      // setIsEditPasswordError(false);
      // setEditPasswordSuccess(false);
      // setEditPasswordError(undefined);
      // setEditPasswordLoading(true);
      return true;
    },
    onError: (data, variables, context) => {
      // setIsEditPasswordError(true);
      // setEditPasswordError(data as any);
      // setEditPasswordLoading(false);
      return true;
    },
    onSuccess: (data, variables, context) => {
      aextendedUserRefetch();
      coachesRefetch();
      setSavedOpen(true);
      if (activeId === login?.id) setLogin(data);
    },
  });








  const headerLine = () => {
    return <>
      <Grid item xs={12} sx={{paddingBottom: "0px !important"}}>
        <Box sx={{
          textAlign: 'right'
        }}>
          <EmailIcon sx={{margin: '0px 9px'}} />
          <Divider />
        </Box>
      </Grid>
    </>;
  }
  const textLine = (text: string, help:string) => {
    return <>
      <Grid item xs={10} sx={{
        paddingBottom: "0px !important",
        paddingTop: "0px !important"
      }}>
        <Typography sx={{
          width: "100%",
          marginTop: 1
        }}>{text}</Typography>
        <Typography sx={{
          fontStyle: 'italic',
          fontSize: '0.9em'
        }}>{help}</Typography>
      </Grid>
    </>;
  }
  const saveUser = () => {
    if (!!extendedUser) {
      mutationSave.mutate({
        formData: {
          object: 'user',
          id: extendedUser.id,
          fields: fields,
          ob: {
            id: extendedUser.id,
            extra_data: {
              emails: {
                ...(extendedUser?.extra_data?.emails || {}),
                account: true
              }
            }
          }
        }
      });
    }
  }

  useEffect(() => {
    if (!!extendedUserTemp) {
      setExtendedUser({
        ...extendedUserTemp,
        extra_data: {
          emails: {
            ...(extendedUserTemp?.extra_data?.emails || {}),
            // ...(extendedUserTemp?.settings?.notifications || {})
          }
        }
      });
    }
  }, [extendedUserTemp]);

  return <Grid container spacing={2}>
    {!!extendedUserLoading && <Grid item xs={12} sx={{textAlign: 'center'}}>
      <CircularProgress />
    </Grid>}
    {!!extendedUser && <>
      {login?.is_super && (coaches || []).length > 1 && <Grid item xs={12}>
        {(coaches || []).map(coach => <Button
          label={coach.full_name || ''}
          id={`coach_${coach.id}`}
          onClick={() => {
            // setFlickerEditor(true);
            setActiveId(coach.id || 0);
            // setTimeout(() => {setFlickerEditor(false);}, 200);
          }}
          contained={activeId === coach.id}
          sx={{
            marginTop: 0,
            marginRight: 1
          }}
        />)}
      </Grid>}

      <Grid item xs={12} sm={6}>
        <Paper sx={{
          padding: 2
        }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("coach.settings.notifications.nutriworkshop.title")}</Typography>
              <Divider />
            </Grid>
            {headerLine()}
            {textLine(t("coach.settings.notifications.nutriworkshop.general"), t("coach.settings.notifications.nutriworkshop.general_help"))}
            <Grid item xs={2} sx={{
              paddingBottom: "0px !important",
              paddingTop: "0px !important",
              textAlign: 'right'
            }}>
              <Checkbox
                color="primary"
                checked={!!extendedUser.extra_data?.emails?.coach_nutri_workshop}
                onChange={(e) => {
                  setExtendedUser({
                    ...extendedUser,
                    extra_data: {
                      ...(extendedUser.extra_data || {}),
                      emails: {
                        ...(extendedUser.extra_data?.emails || {}),
                        coach_nutri_workshop: e.target.checked
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{marginTop: 1}} />
              {!!mutationSave.isPending && <CircularProgress />}
              {!mutationSave.isPending && <Button
                id="save_profile"
                contained
                onClick={(e) => {
                  saveUser();
                }}
                label={t("client.general.buttons.submit", "Opslaan")}
                sx={{
                  marginTop: 1
                }}
              />}
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Paper sx={{
          padding: 2
        }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("coach.settings.nutri_mail.title")}</Typography>
              <Divider />
            </Grid>
            {headerLine()}
            {textLine(t("coach.settings.notifications.nutri_mail.general"), t("coach.settings.notifications.nutri_mail.general_help"))}
            <Grid item xs={2} sx={{
              paddingBottom: "0px !important",
              paddingTop: "0px !important",
              textAlign: 'right'
            }}>
              <Checkbox
                color="primary"
                checked={extendedUser.extra_data?.emails?.nutri_mail}
                onChange={(e) => {
                  setExtendedUser({
                    ...extendedUser,
                    extra_data: {
                      ...(extendedUser.extra_data || {}),
                      emails: {
                        ...(extendedUser.extra_data?.emails || {}),
                        nutri_mail: e.target.checked
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{marginTop: 1}} />
              {!!mutationSave.isPending && <CircularProgress />}
              {!mutationSave.isPending && <Button
                id="save_profile"
                contained
                onClick={(e) => {
                  saveUser();
                }}
                label={t("client.general.buttons.submit", "Opslaan")}
                sx={{
                  marginTop: 1
                }}
              />}
            </Grid>
          </Grid>
        </Paper>
      </Grid>

    </>}

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Grid>;
}

